import React, { useEffect } from "react";

import { IActionList } from "../../../../state";

import styles from "./TabBar.module.scss";

export interface ITabBarProps {
  actionList: IActionList;
  highSchoolCount: number;
  middleSchoolCount: number;
  selectedTab: string;
  setSelectedTab: React.Dispatch<React.SetStateAction<string>>;
  setActiveVolume: React.Dispatch<React.SetStateAction<string | null>>;
}

const TabBar: React.FC<ITabBarProps> = ({
  highSchoolCount,
  middleSchoolCount,
  selectedTab,
  setSelectedTab,
  setActiveVolume,
}) => {
  const showBothTabs = highSchoolCount > 0 && middleSchoolCount > 0;
  const showHighSchoolOnly = highSchoolCount > 0 && middleSchoolCount === 0;
  const showMiddleSchoolOnly = middleSchoolCount > 0 && highSchoolCount === 0;

  useEffect(() => {
    if (showHighSchoolOnly) {
      setSelectedTab("高校");
    } else if (showMiddleSchoolOnly) {
      setSelectedTab("中学");
    }
  }, [showHighSchoolOnly, showMiddleSchoolOnly, setSelectedTab]);

  if (!highSchoolCount && !middleSchoolCount) {
    return null;
  }

  return (
    <>
      {showBothTabs ? (
        <div className={styles.tabBar}>
          <button
            className={`${styles.tab} ${
              selectedTab === "中学" ? styles.activeTab : ""
            }`}
            onClick={() => {
              setSelectedTab("中学");
              setActiveVolume(null);
            }}
          >
            中学
          </button>
          <button
            className={`${styles.tab} ${
              selectedTab === "高校" ? styles.activeTab : ""
            }`}
            onClick={() => {
              setSelectedTab("高校");
              setActiveVolume(null);
            }}
          >
            高校
          </button>
        </div>
      ) : showHighSchoolOnly ? (
        <div className={styles.tabBar}>
          <button className={`${styles.tab} ${styles.activeTab}`}>高校</button>
        </div>
      ) : (
        showMiddleSchoolOnly && (
          <div className={styles.tabBar}>
            <button className={`${styles.tab} ${styles.activeTab}`}>
              中学
            </button>
          </div>
        )
      )}
    </>
  );
};

export default TabBar;
